import { cn } from '@app/shared/utils/common';

interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export function HamburgerButton({ isOpen, onClick }: HamburgerButtonProps) {
  return (
    <button
      className="relative h-8 w-8 shrink-0 text-foreground focus:outline-none"
      onClick={onClick}
    >
      <div className="absolute left-1/2 top-1/2 block w-[18px] -translate-x-1/2 -translate-y-1/2 transform">
        <span
          className={cn(
            'absolute block h-0.5 w-[18px] transform bg-current transition duration-500 ease-in-out',
            isOpen ? 'rotate-45' : '-translate-y-1.5'
          )}
        />
        <span
          className={cn(
            'absolute block h-0.5 w-[18px] transform bg-current transition duration-500 ease-in-out',
            isOpen && 'opacity-0'
          )}
        />
        <span
          className={cn(
            'absolute block h-0.5 w-[18px] transform bg-current transition duration-500 ease-in-out',
            isOpen ? '-rotate-45' : 'translate-y-1.5'
          )}
        />
      </div>
    </button>
  );
}
